"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MawidFirstExtractProblem_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var MawidFirstExtractProblem_Factory = /** @class */ (function () {
    function MawidFirstExtractProblem_Factory() {
    }
    MawidFirstExtractProblem_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ErrorMessage: model.ErrorMessage,
            IsError: model.IsError,
            RecordId: model.RecordId,
        };
        return result;
    };
    MawidFirstExtractProblem_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ErrorMessage: model.ErrorMessage,
            IsError: model.IsError,
            RecordId: model.RecordId,
        };
        return result;
    };
    return MawidFirstExtractProblem_Factory;
}());
exports.MawidFirstExtractProblem_Factory = MawidFirstExtractProblem_Factory;
